// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2I0xB","image":"Header_image__1mBFv","name":"Header_name__24_nk","info":"Header_info__2tnMM","infoRow":"Header_infoRow__2jlOh"};